const GLOBAL_CACHE_KEY = 'reactWithStylesInterfaceCSS';
const MAX_SPECIFICITY = 20;

export { GLOBAL_CACHE_KEY, MAX_SPECIFICITY };
